import React from 'react';
import AboutSection from '../sections/AboutSection';

export default function AboutPage({ brand, processSteps, onShippingWhatsApp, onViewCatalogue }) {
  return (
    <AboutSection
      brand={brand}
      processSteps={processSteps}
      onShippingWhatsApp={onShippingWhatsApp}
      onViewPups={onViewCatalogue}
    />
  );
}
